module.exports = __webpack_public_path__ + "img/mob3.e33013c0.png";